module.exports = __webpack_public_path__ + "static/wellness-47d0a9ce0d84f5a6113d55755178d3f3.jpg";